import { createI18n } from 'vue-i18n'

const locales = require.context('./locales', true, /\.json$/)

const messages = {}

locales.keys().forEach((key) => {
  const locale = key.replace('./', '').replace('.json', '')
  messages[locale] = locales(key)
})

const savedLocale = localStorage.getItem('app-locale') || 'en'

const rtlLanguages = ['ar', 'he', 'fa', 'ur']
const direction = rtlLanguages.includes(savedLocale) ? 'rtl' : 'ltr'
document.documentElement.setAttribute('dir', direction)

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages
})


export default i18n
